import React, {useState} from 'react';
import {Button} from '~/components/Button';
import {useConfirm} from '~/components/Dialogs';
import {IntentText} from '~/components/Form';
import {Title} from '~/components/Title';
import {Intent} from '~/lib/intent';
import {AttributesMenu} from '~/modules/Bidders/components/PreTargetingRules/AttributesMenu';
import {PreTargetingRule} from '~/modules/Bidders/components/PreTargetingRules/PreTargetingRule';
import {IPreTargetingConfig, IPreTargetingVariable} from '~/modules/Bidders/models/PreTargeting';
import {IRule} from '~/modules/Bidders/models/Rule';
import {Schema, SchemaInfo} from '~/modules/Bidders/models/Schema';
import style from './index.module.scss';

export interface IPreTargetingWizardRules {
    preTargetingConfig: IPreTargetingConfig;
    variables: IPreTargetingVariable[];
    schemaInfo: SchemaInfo;
    rules: IRule[];
    onSubmit: (rules: IRule[]) => void;
    onDelete: () => void;
}

export const PreTargetingWizard = ({
    schemaInfo,
    rules: originalRules,
    variables,
    preTargetingConfig,
    onSubmit
}: IPreTargetingWizardRules) => {
    const [rules, setRules] = useState(originalRules);
    const confirm = useConfirm();
    const schema = new Schema(schemaInfo);

    return <div className={style.rulesWizard}>
        <Title toolbar={<>
            <Button leftIcon={<i className='fa fa-file'/>} responsive onClick={() => confirm('Clear rules?', {
                icon: <i className='fa fa-warning'/>,
                intent: Intent.WARNING,
                onOk: () => setRules([])
            })}>Clean</Button>
            <AttributesMenu onSelect={attributeInfo => {
                setRules(schema.concatRules(rules, Schema.buildRule(attributeInfo)));
            }} schema={schema} children='Add'/>
            <Button intent={Intent.PRIMARY} leftIcon={<i className='fa fa-save'/>} responsive
                onClick={() => onSubmit(rules)}>Save</Button>
        </>}
        >{preTargetingConfig.title}</Title>
        <div className={style.rulesList}>
            {rules.length === 0 ? <IntentText>No rules</IntentText> :
                rules.map((rule, index) => <PreTargetingRule
                    key={index}
                    rule={rule}
                    schema={schema}
                    variables={variables.map(variable => variable.name)}
                    onDelete={() => {
                        delete rules[index];
                        setRules(rules.filter(filterRule => !!filterRule));
                    }}
                    onChange={(r) => {
                        rules[index] = r;
                        setRules([...rules]);
                    }}
                />)
            }
        </div>
    </div>;
};
